import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    width: '100%',
  },
  styledText: {
    paddingBottom: theme.typography.pxToRem(24),
  },
  styledLink: {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
  },
  styledBold: {
    fontWeight: 'bold',
  },
  styledImage: {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
  },
  responsiveEmbedContainer: {
    width: '100%',
    position: 'relative',
  },
  styledVideoEmbed: {
    border: '0px',
    verticalAlign: 'bottom',
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    paddingBottom: theme.spacing(2),
  },
  styledAudioEmbed: {
    width: '100%',
    padding: theme.spacing(2, 0),
    border: 'none',
  },
  styledDiv: {
    width: '100%',
  },
  /**
   * NOTE: instagram embeds have min-width of 320px
   * This may cause overflow issues on really small
   * screens. However, mitigating this would have the
   * need to remove all padding surrounding the post
   * This causes the component to be absolutely positioned
   * in the screen. Thus we opt out of supporting
   * a really small view port.
   */
  socialMediaEmbedContainer: {
    overflow: 'scroll',
    width: 'unset',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    position: 'relative',
  },
  styledBlockQuote: {
    margin: 0,
    width: '100%',
    padding: theme.spacing(2),
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.12)' // Subtle light overlay in dark mode
        : theme.palette.custom.grey.light, // Light grey in light mode
    color: theme.palette.primary.light,
    fontStyle: 'italic',
    fontWeight: 400,
    // TODO OVERRIDE
    fontSize: theme.typography.pxToRem(21),
    marginBottom: theme.typography.pxToRem(24),
    '& p': {
      paddingBottom: 0,
    },
    '& [data-postbody-p]': {
      paddingBottom: 0,
    },
  },
}));
